import { every, find, filter, head, isBoolean, isNull, keys } from 'lodash'
import commonGetters from '@/store/data/common/getters'

const getters = {
    getWamCustomTaxoLabelByType: state => params => {
        const _type = params.type === 'data' ? 'direct' : params.type === 'customTaxonomies' ? 'custom' : params.type
        const taxo = find(state.customTaxonomies, _taxo => _taxo.taxonomy_type === _type)
        if (taxo) return 'Taxonomies'
    },

    getWamCustomTaxoLabelById: state => params => {
        const taxo = find(state.customTaxonomies, _taxo => _taxo.id == params.taxoId)
        if (taxo) return taxo.label
    },

    getWamCustomTaxoId: state => params => {
        const _type = params.type === 'data' ? 'direct' : params.type
        let taxo
        if (params.type !== 'custom') {
            taxo = find(state.customTaxonomies, _taxo => _taxo.taxonomy_type === _type)
        }
        if (taxo) return taxo.id
    },

    getItemByJsonKeyNameHierarchy: (_state, getters) => ({ jsonKeyName }) => {
        return head(getters.getSearchedItemsHierarchy({ jsonKeyName })) || null
    },

    getCurrentTaxonomyHierarchy: state => () => {
        return state.selected ? state.hierarchies[state.selected] : []
    },

    getSearchedItemsHierarchy: (_state, getter) => params => {
        const res = filter(getter.getAllHierarchies(), item => {
            return every(keys(params), field => {
                if (isNull(params[field])) {
                    return true
                } else if (isBoolean(params[field])) {
                    return item[field] === params[field]
                } else if (field === 'input') {
                    return (
                        String(item['id'])
                            .toLowerCase()
                            .indexOf(String(params.input).toLowerCase()) > -1 ||
                        String(item['label'])
                            .toLowerCase()
                            .indexOf(String(params.input).toLowerCase()) > -1
                    )
                } else if (field === 'id') {
                    return parseInt(item[field]) === parseInt(params[field])
                } else if (field === 'type') {
                    return item.type === params[field]
                } else if (field === 'status') {
                    return item[field] === params[field]
                } else if (field === 'jsonKeyName') {
                    return item.jsonKey.name === params[field]
                } else if (field === 'jsonKeyNames') {
                    return params[field].includes(item['jsonKey']['name'])
                } else if (field === 'jsonKeyType') {
                    return item.jsonKey.type === params[field]
                } else {
                    return item[field].match(params[field])
                }
            })
        })
        return res
    },

    /**
     *
     * @param {Object} state - vuex state for customtTaxonomie module
     * @returns {Object[]} Array of all hierachies
     */
    getAllHierarchies: state => () => {
        return Object.values(state.hierarchies).flat()
    },

    /**
     * Check that the get of taxonomies and hierarchies do not load
     * and that we have one hierachy per taxonomy
     *
     * @param {Object} state - vuex state for customtTaxonomie module
     * @returns {Boolean}
     */
    isReadyForCriteriaList: state => () => {
        return !state.isLoading && state.customTaxonomies.every(taxonomie => state.hierarchies[taxonomie.id])
    },

    /**
     * Retrieves a taxo by id one of his segment id
     *
     * @param {Object} segment Rhe segment which you want to get the taxoId
     * @param {Number} segment.id
     * @returns {Number} A taxonomy id
     */
    getWamCustomTaxoIdBySegmentId: (_state, getter) => ({ id }) => {
        const cs = getter.getAllHierarchies().find(i => i.id == id)
        return cs.taxonomyId
    },

    taxonomiesCount: (state) => state.taxonomiesCount,
    segmentsCount: (state) => state.segmentsCount,
    builderIsLoading: (state) => state.builderIsLoading,
}

export default { ...commonGetters, ...getters }
